import styled from 'styled-components/macro';

const Name = styled.div`
  line-height: 24px;
  box-sizing: border-box;
  font-size: 18px;
`;

export default Name;
